import React from "react";
import "../../css/featured.css";
import ExploreMore from "../../ExploreMore";
import Navbar from "../../Navbar";
export const Tiktokban = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            Supreme Court Rejects Appeal, TikTok Faces U.S. Ban by Sunday.
          </h1>
          {/* <div className="article-category">
            Canada's 10 Most Influential Women Leaders to Watch in 2024
          </div> */}
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/navnews/tik-tok.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            {/* <div className="article-image-caption">
            
            </div> */}
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
              A former cybersecurity advisor to President Barack Obama has
              criticized the Supreme Court's decision to uphold the TikTok ban,
              calling it "rushed." Timothy Edgar, a former ACLU lawyer and
              member of Obama’s National Security Council, contributed to a
              brief supporting TikTok’s appeal. Speaking on Radio 4’s PM program
              with Anita Anand, Edgar expressed surprise at the unanimous
              ruling, stating he was “frankly disappointed with the reasoning.”
              Edgar argued that Americans “deserved a better process” and
              claimed the decision overlooked critical issues raised in the
              brief. “This was a very important free speech case,” Edgar said,
              describing it as “the most significant free speech case in a
              generation.” He also doubted whether former President Trump could
              overturn the ruling, noting, “Congress enacted this law, and only
              Congress can repeal it.” Edgar further expressed skepticism about
              the possibility of TikTok being sold.
              <h4>US Content Creators Respond to TikTok Ban</h4> Searching
              “TikTok ban” on the app reveals a wave of reactions from creators
              of all sizes, reflecting uncertainty about its future. Joe and
              Frank Mele, a father-and-son comedy duo with over 30 million
              followers, admitted they’re unsure about what the ban means for
              TikTok’s longevity. “We’ll keep posting while we can,” they shared
              in a video posted Friday, adding, “In case the ban comes quicker
              than we hope, we just wanted to say thank you.” Meanwhile, other
              creators are embracing humor, joining a trend of lip-syncing to a
              Family Guy quote or voicing hope that YouTuber MrBeast might “save
              TikTok” after he expressed interest in buying the app on X.
            </p>
          </div>
        </div>
      </div>
      <ExploreMore />
    </>
  );
};
